import axios, { AxiosInstance } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { readCookie } from '../utils/cookieUtils';
import { isLocalEnv } from '../common/functions/isLocalEnv';
import { splunk_log_type, splunk_message } from '../common/splunk_constant';

export interface LoginDto {
  username: string;
  password: string;
}

export const AuthService = {
  login: async (
    visionBffClient: AxiosInstance,
    loginDto: LoginDto,
    splunkLogger?:any
  ): Promise<{ region?: string; [key: string]: any } | { error: string }> => {
    try {
      const response = await visionBffClient({
        method: 'POST',
        url: '/api/v1/login',
        data: loginDto,
      });
      splunkLogger?.({
        logType: splunk_log_type.INFO,
        data: splunk_message.SUCCESS.LOGIN_SUCCESS
      })
      return response?.data;
    } catch (err: any) {
      console.log(err);
      splunkLogger?.({
        logType: splunk_log_type.ERROR,
        data: { ...splunk_message.ERROR.LOGIN_ERROR, err}
      })
      if (err?.response?.status === 401) {
        return { error: 'login.401.error' };
      } else {
        return { error: 'login.standard.error' };
      }
    }
  },
  logout: async (visionBffClient: AxiosInstance, splunkLogger?: any): Promise<boolean | { error: string }> => {
    try {
      const graphQLDto = {
        query: `
        mutation {
          logoutUser
        }
        `,
      };

      const response = await visionBffClient({
        method: 'POST',
        url: '/api/v1/user',
        data: graphQLDto,
      });
      splunkLogger?.({
        logType: splunk_log_type.INFO,
        data: splunk_message.SUCCESS.LOGOUT_SUCCESS
      })
      return response?.data;
    } catch (err: any) {
      console.log(err);
      splunkLogger({
        logType: splunk_log_type.ERROR,
        data: { ...splunk_message.ERROR.LOGOUT_ERROR, err}
      })
      if (err?.response?.status === 404) {
        return { error: 'loginout.404.error' };
      } else {
        return { error: 'loginout.standard.error' };
      }
    }
  },
  // TODO: Create a kpd client in common useServiceClients hook
  kpdLogout: async (url: string, timeout: number, splunkLogger?: any): Promise<boolean | { error: string }> => {
    try {
      var headers = { 'x-correlation-id': process.env.NODE_ENV === 'test' ? '' : uuidv4() };

      if (isLocalEnv()) {
        if (readCookie('temp-obsso')) {
          headers['x-guid'] = JSON.parse(readCookie('temp-obsso'))['x-guid'];
        }
      }

      const response = await axios({
        method: 'GET',
        url: `${url}`,
        withCredentials: true,
        headers,
        timeout,
      });
      splunkLogger?.({
        logType: splunk_log_type.INFO,
        data: splunk_message.SUCCESS.KPD_LOGOUT_SUCCESS
      })
      return response?.data;
    } catch (err: any) {
      console.log(err);
      splunkLogger?.({
        logType: splunk_log_type.ERROR,
        data: { ...splunk_message.ERROR.KPD_LOGOUT_ERROR, err}
      })
      if (err?.response?.status === 404) {
        return { error: 'loginout.404.error' };
      } else {
        return { error: 'loginout.standard.error' };
      }
    }
  },
};
